import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { useNavigate } from "react-router-dom";
import {
  convert,
  change,
  mdifMontantToChange,
  deviseToChange,
} from "../../app/services/changeSlice";

import {
  Alert,
  Avatar,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
// import Select from "@mui/joy/Select";
import BasicSelect from "./BasicSelect";
import SyncIcon from "@mui/icons-material/Sync";
// import { GifBox } from "@mui/icons-material";
import axios from "axios";
import "./style.css";
import Loader from "../loader/Loader";
// import { useGetAllDevisesQuery } from "../../app/services/deviseApi";
// import { change } from "../../app/services/changeSlice";
import { useSelector, useDispatch } from "react-redux";
import { useGetCourQuery } from "../../app/services/courApi";
import TypeOperation from "./TypeOperation";
import AddCoursModel from "../cours/AddCoursModel";
import CarteInfoBureau from "../reservation/CarteInfoBureau";
// import { mdifMontantToChange } from "../../app/services/changeSlice";

const CalculatorAchat = (props) => {
  const { data, isLoading, isSuccess, isError, error } = useGetCourQuery(
    props.bureauId
  );

  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  const currentDate = date + "/" + month + "/" + year;

  const [selectedCour, setSelectedCour] = useState(null);
  const [receiveSelectValue, setReceiveSelectValue] = useState("");

  const [montantDevise, setMontantDevise] = useState("");
  const [montantLocal, setMontantLocal] = useState("");

  const [giveSelectValue, setGiveSelectValue] = useState("");
  const [modified, setModified] = useState(false);
  const [prix, setPrix] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const state = useSelector((state) => state.change.value);
  useEffect(() => {
    if (data?.Bureau?.cours && props.deviseId) {
      const cour = data.Bureau.cours.find(
        (c) => c.devise.id === parseInt(props.deviseId)
      );
      if (cour) {
        setSelectedCour(cour);
        setReceiveSelectValue(cour.devise.name); // mettre à jour aussi le combo
      }
    }
  }, [data, props.deviseId]);

  if (isLoading) {
    return <Loader />;
  }

  if (!data?.Bureau?.cours) {
    return <Alert severity="error">Erreur de chargement des devises</Alert>;
  }

  const members = data.Bureau.cours.map((cour) => (
    <MenuItem value={cour.devise.name} key={cour.id}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Avatar
          alt={cour.devise.name}
          src={`${process.env.REACT_APP_BASE_FILE_URL}/Devise/image/${cour.devise.image}`}
          sx={{ width: 24, height: 24 }}
        />
        {cour.devise.name}
      </Box>
    </MenuItem>
  ));

  const handleChange = (typeChange) => (event) => {
    const selectedDeviseName = event.target.value;
    setMontantLocal(0);
    setMontantDevise(0);

    // Recherche du cours correspondant à la devise sélectionnée
    const selected = data?.Bureau?.cours?.find(
      (cour) => cour.devise.name === selectedDeviseName
    );

    // Mise à jour du state local selectedCour
    if (selected) {
      setSelectedCour(selected);
    }
    if (typeChange === "give") {
      // dispatch(convert("achat"));
      setGiveSelectValue(event.target.value);
    } else if (typeChange === "receive") {
      // dispatch(convert("vente"));
      setReceiveSelectValue(event.target.value);
    }
  };

  const handleChange1 = (event) => {
    setMontantLocal(event.target.value);
    setMontantDevise((event.target.value / selectedCour.prixVente).toFixed(2));
  };
  //
  const handleChange2 = (event) => {
    const m1 = (event.target.value / (prix * 1000)) * 1000;
    setMontantDevise(event.target.value);
    setMontantLocal((event.target.value * selectedCour.prixVente).toFixed(2));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      sx={{
        padding: 2,
        justifyContent: "space-between",
        color: "black",
      }}
    >
      <Stack
        direction="column"
        sx={{
          // backgroundColor: "white",
          // padding: 2,
          // marginBottom: 4,

          maxWidth: "520px",
          // borderRadius: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#131312",
            color: "white",
            borderRadius: 2,
            padding: 2,
          }}
        >
          <Typography variant="body1" align="center">
            Sélectionnez la devise que vous souhaitez acheter, puis saisissez le montant.
          </Typography>
          <Stack
            direction={{ xs: "column-reverse", sm: "row-reverse" }}
            spacing={2}
            sx={{
              borderColor: "black",
              backgroundColor: "goldenrod",
              borderRadius: 2,
              borderStyle: "solid",
              padding: 1,
              input: { color: "yellow", fontSize: "1.5em" },
            }}
          >
            <TextField
              sx={{
                backgroundColor: "goldenrod",
                borderColor: "goldenrod",
                minWidth: "200px",
                padding: 0,
                borderStyle: "solid",
                input: { color: "yellow", fontSize: "1.2em" },
              }}
              id="t2"
              label="Achat"
              type="number"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{ min: 0 }}
              value={montantDevise}
              onChange={handleChange2}
              onFocus={(e) => e.target.select()}
            />

            <Box sx={{ minWidth: "200px", color: "red" }}>
              <FormControl fullWidth>
                <InputLabel id="receive-select-label">Devise</InputLabel>
                <Select
                  labelId="receive-label"
                  id="receive"
                  // value={"EURO"}
                  label="Devise"
                  size="small"
                  defaultValue="MAD Marocain"
                  value={receiveSelectValue}
                  onChange={handleChange("receive")}
                >
                  {members}
                </Select>
              </FormControl>
            </Box>
          </Stack>
        </Box>

        <Box
          sx={{
            // padding:2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography variant="h4">
            <SyncIcon
              sx={
                {
                  // fontSize:'32px'
                }
              }
            />
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "#131312",
            color: "white",
            borderRadius: 2,
            padding: 2,
          }}
        >
          <Typography variant="h6" align="center">
            Montant à payer en dirhams
          </Typography>
          <Stack
            direction={{ xs: "column-reverse", sm: "row-reverse" }}
            spacing={2}
            sx={{
              borderColor: "goldenrod",
              backgroundColor: "goldenrod",
              borderRadius: 2,
              borderStyle: "solid",
              padding: 1,
              input: { color: "yellow", fontSize: "1.5em" },
            }}
          >
            <TextField
              className="zonetext"
              sx={{
                minWidth: "110px",
                padding: 0,
                borderStyle: "solid",
                input: { color: "yellow", fontSize: "1.2em" },
              }}
              id="t1"
              label="Je paye"
              type="number"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              // inputRef={inputRef}
              inputProps={{ min: 0 }}
              value={montantLocal}
              onChange={handleChange1}
              onFocus={(e) => e.target.select()}
            />

            <Box sx={{ minWidth: "200px", color: "red" }}>
              <FormControl fullWidth disabled>
                <InputLabel id="give-select-label">Monnaie locale</InputLabel>
                <Select
                  labelId="give-label"
                  id="give"
                  value="MAD Marocain"
                  label="Devise"
                  size="small"
                  defaultValue="MAD Marocain"
                  // onChange={handleChange("give")}
                >
                  <MenuItem value="MAD Marocain">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Avatar
                        alt="Remy Sharp"
                        src="/images/devise/maroc.jpg"
                        sx={{ width: 32, height: 32 }}
                      />
                      MAD Marocain
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
              {/* <Typography variant="h1">depasse: {montantDepasse} </Typography> */}
            </Box>
          </Stack>
        </Box>
      </Stack>
      <Box>
        <Typography variant="h5">Bureau de retrait</Typography>

        <CarteInfoBureau Bureau={data?.Bureau} />
        {montantDevise != 0 && (
          <>
            <Typography variant="h5">Montant de reservation</Typography>

            <Stack
              direction="row"
              spacing={2}
              sx={{
                padding: 2,
                justifyContent: "space-between",
                color: "black",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    marginBottom: 0,
                    fontSize: "0.875rem", // Taille réduite (~14px)
                  }}
                >
                  <Typography variant="body2">
                    Vous achetez un montant de{" "}
                    <strong>
                      {montantDevise} {selectedCour.devise.name}
                    </strong>
                  </Typography>
                  <Typography variant="body2">
                    contre un montant de <strong>{montantLocal} MAD</strong>
                  </Typography>
                </Typography>

                <Typography variant="caption">
                  avec le taux: 1 {selectedCour.devise.name} ={" "}
                  {Number(selectedCour.prixVente).toFixed(2)} MAD
                </Typography>

                {montantLocal > 100000 && (
                  <Alert severity="error">
                    Attention ! Vous avez dépassé 100 000,00 Dirhams
                  </Alert>
                )}
              </Box>

              <Box>
                <Typography variant="body2">Le {currentDate}</Typography>
                <Typography variant="body2">
                  {today.toLocaleTimeString()}
                </Typography>
              </Box>
            </Stack>
          </>
        )}
        <Stack
          direction={"row"}
          spacing={2}
          sx={{
            display: "flex",
            justifyContent: "start",
            paddingBottom: 2,
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            sx={{
              backgroundColor: "black",
              color: "goldenrod",
            }}
            onClick={() => {
              // navigate("/reservation/retraitinfo");
              navigate("/reservation");
            }}
          >
            Précédent
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "black",
              color: "goldenrod",
            }}
            disabled={montantDevise == 0}
            onClick={() => {
              dispatch(
                change({
                  cour: selectedCour,
                  bureau: data?.Bureau,
                  devise: selectedCour.devise,
                  TypeOperation: "vente",
                  montantToExchane: montantLocal,
                  MontantToReceive: montantDevise,
                  // steep: 1,
                })
              );
              // navigate("/reservation/retraitinfo");
              navigate("/reservation/reservationclient");
            }}
          >
            Suivant
          </Button>
          {/* <AddCoursModel /> */}
        </Stack>
      </Box>
    </Stack>
  );
};

export default CalculatorAchat;
